import axios from "axios";

export function protectedSubmission(url,method="get"){
 if(!["post","put","patch","delete"].includes(method.toLowerCase()))return false;
 const path=url.replace(/^https?:\/\/[^/]+/,"").replace(/^\/api/,"").split("?")[0];
 return ["/auth/login","/v1/pharmacy/auth/login","/auth/forgot-password","/auth/reset-password","/auth/register-clinic","/auth/activate-clinic-admin","/auth/patient-registration/verify","/auth/google/session","/appointments/patient-book","/appointments/public/book","/v1/pharmacy/applications"].includes(path)||path.startsWith("/public/")||path.startsWith("/v1/public/")||/^\/v1\/pharmacy\/customer\/(?:orders(?:\/[^/]+\/(?:accept|clarify|pay))?|prescriptions\/[^/]+)$/.test(path)||/^\/appointments\/[^/]+\/patient-(?:cancel|reschedule)$/.test(path);
}
let cached,pending,expires=0;
export async function captchaConfiguration(refresh=false){
 if(!refresh&&cached&&Date.now()<expires)return cached;
 if(!pending)pending=axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/security/captcha-config`).then(r=>{cached=r.data;expires=Date.now()+30000;return cached;}).finally(()=>{pending=null;});
 return pending;
}
export async function requestCaptcha(refresh=false){
 const config=await captchaConfiguration(refresh);if(!config.enabled)return "";
 return new Promise((resolve,reject)=>window.dispatchEvent(new CustomEvent("mg-captcha-request",{detail:{siteKey:config.site_key,resolve,reject}})));
}
let scriptPromise;
export function loadCaptcha(){
 if(window.grecaptcha?.render)return Promise.resolve(window.grecaptcha);
 if(!scriptPromise)scriptPromise=new Promise((resolve,reject)=>{
  window.medigenieCaptchaReady=()=>resolve(window.grecaptcha);
  const script=document.createElement("script");script.src="https://www.google.com/recaptcha/api.js?onload=medigenieCaptchaReady&render=explicit";script.async=true;script.defer=true;
  const timer=setTimeout(()=>{scriptPromise=null;reject(new Error("Security check could not load. Please try again."));},15000);
  script.onerror=()=>{clearTimeout(timer);scriptPromise=null;reject(new Error("Security check could not load. Please try again."));};
  window.medigenieCaptchaReady=()=>{clearTimeout(timer);resolve(window.grecaptcha);};document.head.appendChild(script);
 });
 return scriptPromise;
}
